import {dayjs, formatDateISO, momentify} from "../../shared/js/dateUtils";

$(function(){
    $('.age-option').click(function () {
        const ageVal = $(this).prop('value');
        $('#age').prop('value', ageVal);
    });
    $('.age-selector').change(function () {
        const ageVal = $(this).val();
        $('#age').prop('value', ageVal);
    });
    // Vehicle type
    document.getElementById('dd-car-list')?.addEventListener('click', function (event){
        var dropdown = document.querySelector('.dd-list-car');
        if (!dropdown.classList.contains('hidden') && dropdown.classList.contains('block')) {
            dropdown.classList.add('hidden');
            dropdown.classList.remove('block');
        } else {
            dropdown.classList.remove('hidden');
            dropdown.classList.add('block');
        }
        event.stopPropagation();
    });

    document.addEventListener('click', function (event) {
        var dropdown = document.querySelector('.dd-list-car');
        if (!dropdown?.contains(event.target) && !document.getElementById('dd-car-list')?.contains(event.target)) {
            dropdown?.classList.add('hidden');
            dropdown?.classList.remove('block');
        }
    });

    var targetSpan = document.querySelector('.list-checkbox li#dropdown-car-list label span.car-name');
    var targetImage = document.querySelector('.list-checkbox li#dropdown-car-list label img');

    document.querySelectorAll('.dd-list-car ul li label input').forEach(function (checkbox) {
        if (checkbox.checked) {
            var spanText = checkbox.nextElementSibling.querySelector('span.text-grey-3').innerText;
            // Replace the image and text with the selected car
            var imageSrc = checkbox.nextElementSibling.querySelector('img').src;
            var imageAlt = checkbox.nextElementSibling.querySelector('img').alt;
            targetImage.src = imageSrc;
            targetImage.alt = imageAlt;
            targetSpan.innerHTML = ' ' + spanText;

            // Add the <i></i> icon
            var icon = document.createElement('i');
            icon.classList.add('fa-solid', 'fa-chevron-down', 'ml-[6.5px]', 'text-grey-3', 'text-xs');
            targetSpan.appendChild(icon);

            document.getElementById('dd-car-list').classList.add('active-type');
        }

        checkbox.addEventListener('click', function () {
            var spanText = this.nextElementSibling.querySelector('span.text-grey-3').innerText;
            var dropdownarea = document.querySelector('.dd-list-car');

            // Uncheck all other checkboxes and remove their images and text
            document.querySelectorAll('.dd-list-car ul li label input').forEach(function (otherCheckbox) {
                if (otherCheckbox !== checkbox) {
                    otherCheckbox.checked = false;
                }
            });

            // If targetImage doesn't exist, create it
            if (!targetImage) {
                targetImage = document.createElement('img');
                targetImage.classList.add('selected-car-image');
                document.querySelector('.list-checkbox li#dropdown-car-list label').prepend(targetImage);
            }

            if (this.checked) {
                // Replace the image and text with the selected car
                var imageSrc = this.nextElementSibling.querySelector('img').src;
                var imageAlt = this.nextElementSibling.querySelector('img').alt;
                targetImage.src = imageSrc;
                targetImage.alt = imageAlt;
                targetSpan.innerHTML = ' ' + spanText;

                // Add the <i></i> icon
                var icon = document.createElement('i');
                icon.classList.add('fa-solid', 'fa-chevron-down', 'ml-[6.5px]', 'text-grey-3', 'text-xs');
                targetSpan.appendChild(icon);

                document.getElementById('dd-car-list').classList.add('active-type');
            } else {
                // Clear the image and text if unchecked
                targetImage.src = './assets/images/other-car.svg';
                targetImage.alt = 'other';
                targetSpan.innerHTML = 'other';

                // Add the <i></i> icon
                var icon = document.createElement('i');
                icon.classList.add('fa-solid', 'fa-chevron-down', 'ml-[6.5px]', 'text-grey-3', 'text-xs');
                targetSpan.appendChild(icon);

                document.getElementById('dd-car-list').classList.remove('active-type');
            }

            // Close the dropdown after selecting an input
            dropdownarea.classList.add('hidden');
            dropdownarea.classList.remove('block');
        });
    });

    $('.vehicallist-hero .select-radio').click(function () {
        $('#dd-car-list.active-type').removeClass('active-type');
    });
    setTimeout(function() {
        var debounce = null;
        // mobile search
        $('.search-result-popup #searchInput').keyup(function () {
          let searchQuery = $(this).val().toLowerCase();
          let noResultsMessage = document.getElementById('noResultsMessage');
          let searchSpinner = document.getElementById('searchSpinner');

          // Reset error message
          noResultsMessage.style.display = 'none';
          searchSpinner.style.display = 'block';
          $('#search-area').children().remove();
          clearTimeout(debounce);
          debounce = setTimeout(function() {
            $.ajax({
              url: '/ajax-search-city',
              dataType: 'json',
              data: {
                query: searchQuery
              },
              success: function (data) {
                noResultsMessage.style.display = 'none';
                searchSpinner.style.display = 'none';
                $('#search-area').children().remove();

                data.suggestions.forEach(suggestion => {
                  $('#search-area').append('<li class="country-name" data-value="' + suggestion.value + '">' + suggestion.name + '</li>');
                });

                $('#search-area li').click(function () {
                  selectCity(this);
                });

                if (searchQuery) {
                  $('.country-search-input .close_icons_country').show();
                } else {
                  $('.country-search-input .close_icons_country').hide();
                }

                if (!data.suggestions.length) {
                  noResultsMessage.style.display = 'block';
                }
              }
            });
          }, 300);
        });

        function selectCity(el) {
          $('#search-area li').removeClass('active');
          var clickedText = $(el).text();
          var dataValue = $(el).attr('data-value');
          $('#postal').prop('value', clickedText);
          $('#search_country_select li.js_init').text(clickedText);
          $('#search_country_select li.js_init').addClass('active');
          $(el).addClass('active');
          $('#search_country_select li.js_init').attr('data-value', dataValue);
          $('#search-result-popup').hide();
          $('a.close_icons_country.outside-search').show();
        }

        $('#search_country_select li.js_init').on('click', function () {
            $('#search-result-popup').show();
        });

        $('a.close_icons_country').on('click', function () {
            $('#search-area li').removeClass('active');
            $('#search_country_select li.js_init').removeClass('active');
            $('#search_country_select li.js_init').text(window.i18next.t('first_page.subscription.anywhere'));
            $('#search_country_select li.js_init').removeAttr('data-value');
            $('#postal').prop('value', "");
            $('a.close_icons_country').hide();
            $('#searchInput').val('');
            $('#noResultsMessage').hide();
            $('#search-area li').show();
        });
        $('p#close_search_popup').on('click', function () {
            $('#search-result-popup').hide();
        });

        function searchString(searchString, hayString) {
            if (hayString.length < searchString.length) {
                return false;
            }

            for (let i = 0; i < searchString.length; i++) {
                if (searchString[i] !== hayString[i]) {
                    return false;
                }
            }
            return true;
        }


        $("#selectedCountry").on("click", function () {
            $("#countryDropdown").show();
        });

        $("#tags-country").autocomplete({
            source: function( request, response ) {
              $.getJSON( "/ajax-search-city", {
               query: $('.search-box-zip').val().toLowerCase()
              }, function (data) {
                response(data.suggestions);
              });
            },
            open: function(event, ui) {
                // Create a new li at the beginning of the list
                var newLi = $("<div>").addClass('country-text')
                  .append("<div class='close-icon-text'><div class='close-icon-search'></div>" + window.i18next.t('first_page.subscription.search_city_or_zip') + "</div>");
                $(".ui-autocomplete").prepend(newLi);
                var acData = $(this).data('ui-autocomplete');
                acData.menu.element.find('li').each(function () {
                    var me = $(this);
                    var keywords = acData.term.split(' ').join('|');
                    me.html(me.text().replace(new RegExp("(" + keywords + ")", "gi"), '<strong>$1</strong>'));
                });
            },
            select: function(e, el) {
                $("#postal").prop('value', el.item.value)
            },
            close: function(event, ui) {

            }
        })
        .autocomplete( "instance" )._renderItem = function( ul, item ) {
          return $( `<li class=\"country-name\" data-value="${item.value}">` )
            .append(`<div>${item.name}</div>`)
            .appendTo( ul );
        };
        $(document).on('click', '.ui-autocomplete .country-text .close-icon-search', function() {
            $('.ui-autocomplete').hide();
        });

        $('.search-box-zip').on('input', function() {
            var inputValue = $(this).val().trim();
            var closeButton = $('#close_icons');
            closeButton.toggle(inputValue !== '');
            closeButton.on('click', function() {
                $(this).prev('.search-box-zip').val('').end().hide();
                $("#postal").prop('value', "")
            });
        });

        $(".hero .dropdown .age-drop").click(function () {
            $(".hero .dropdown-content").toggleClass('hidden');
        });
        $(".hero .dropdown-content a").click(function () {
            var selectedValue = $(this).text();
            $(".hero .dropdown .age-drop").text(selectedValue);
            $(".hero .dropdown-content").addClass('hidden');
        });

        $(".hero .dropdown-rental #age-drop").click(function () {
            $(".hero .dropdown-rental .dropdown-content-rental").toggleClass('hidden');
        });
        $(".hero .dropdown-content-rental a").click(function () {
            var selectedValue = $(this).text();
            $(".hero .dropdown-rental #age-drop").text(selectedValue);
            $(".hero .dropdown-content-rental").addClass('hidden');
        });

        $(".flatpickr-close").on("click", function() {
            $(".flatpickr-calendar").removeClass("open");
        });

        $("#datepicker-picker").on("click", function() {
            $(".flatpickr-calendar").addClass("open");
        });

        // Mobile dates load click events
        var visibleMonths = 4;
        $('#load_dates_mobile').on('click', function () {
            $('.dayContainer').slice(visibleMonths, visibleMonths + 4).css('display', 'grid');
            $('.all-months-name .months-load-more:nth-child(-n+' + (visibleMonths + 4) + ')').css('display', 'block');
            visibleMonths += 4;
            if (visibleMonths >= $('.dayContainer').length) {
                $('#load_dates_mobile').css('display', 'none');
            }
        });

        // open flatpickr body class add
        const body = $('body');
        const calendar = $('.flatpickr-calendar');
        if (calendar.length && calendar.hasClass('open')) {
            body.addClass('overflow-hidden');
        } else {
            body.removeClass('overflow-hidden');
        }
    }, 500);

    $('.search-box-zip').change(function () {
      $('[name="postal"]').val($(this).val());
    })
});

document.addEventListener('DOMContentLoaded', function () {
    var isAdMobileDate = window.innerWidth <= 767;

    var isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent);
    const isMobileScreen = window.innerWidth <= 767;

  const closeIconDate = document.querySelector("#close_icon_date");

    var homepagecarsubConfig = {
        locale: {
          ...window.appLocale,
          firstDayOfWeek: window.weekStartDay,
          weekdays: {
            shorthand: [
              window.i18next.t('first_page.calendar.sunday'),
              window.i18next.t('first_page.calendar.monday'),
              window.i18next.t('first_page.calendar.tuesday'),
              window.i18next.t('first_page.calendar.wednesday'),
              window.i18next.t('first_page.calendar.thursday'),
              window.i18next.t('first_page.calendar.friday'),
              window.i18next.t('first_page.calendar.saturday'),
            ],
            longhand: [
              window.i18next.t('calendar.week_day.sunday.long'),
              window.i18next.t('calendar.week_day.monday.long'),
              window.i18next.t('calendar.week_day.tuesday.long'),
              window.i18next.t('calendar.week_day.wednesday.long'),
              window.i18next.t('calendar.week_day.thursday.long'),
              window.i18next.t('calendar.week_day.friday.long'),
              window.i18next.t('calendar.week_day.saturday.long'),
            ]
          },
          months: {
            shorthand: [
              window.i18next.t('calendar.month.january.short'),
              window.i18next.t('calendar.month.february.short'),
              window.i18next.t('calendar.month.march.short'),
              window.i18next.t('calendar.month.april.short'),
              window.i18next.t('calendar.month.may.short'),
              window.i18next.t('calendar.month.june.short'),
              window.i18next.t('calendar.month.july.short'),
              window.i18next.t('calendar.month.august.short'),
              window.i18next.t('calendar.month.september.short'),
              window.i18next.t('calendar.month.october.short'),
              window.i18next.t('calendar.month.november.short'),
              window.i18next.t('calendar.month.december.short'),
            ],
            longhand: [
              window.i18next.t('calendar.month.january.long'),
              window.i18next.t('calendar.month.february.long'),
              window.i18next.t('calendar.month.march.long'),
              window.i18next.t('calendar.month.april.long'),
              window.i18next.t('calendar.month.may.long'),
              window.i18next.t('calendar.month.june.long'),
              window.i18next.t('calendar.month.july.long'),
              window.i18next.t('calendar.month.august.long'),
              window.i18next.t('calendar.month.september.long'),
              window.i18next.t('calendar.month.october.long'),
              window.i18next.t('calendar.month.november.long'),
              window.i18next.t('calendar.month.december.long'),
            ]
          }
        },
        dateFormat: window.jsDateFormat,
        minDate: "today",
        defaultDate: window.startingFrom,
        showMonths: isMobile ? 20 : 2,
        position: 'below',
        disableMobile: true,
        parseDate: (datestr, format) => {
          return dayjs(datestr, window.jsDateFormats, true).toDate();
        },
        formatDate: (date, format, locale) => {
          return dayjs(date).format(format);
        },
        onChange: function(selectedDates, dateStr, instance) {
          if (dateStr !== "") {
            closeIconDate.style.display = "block";
          } else {
            closeIconDate.style.display = "none";
          }
        }
    };

    closeIconDate.addEventListener("click", function() {
        homepagecarsubDate._flatpickr.clear();
        $("#starting_from").prop('value', "")
        closeIconDate.style.display = "none";
    });


    const homepagecarsubDate = document.querySelector("#datepicker-picker");

    const calendar = flatpickr(homepagecarsubDate, {
        ...homepagecarsubConfig,
        onReady: function(selectedDates, dateStr, instance) {
            const calendarContainer = instance.calendarContainer;
            calendarContainer.classList.add('carsub_datepicker', 'rental_start_end');

            showCalendarFromToday(instance)
        },
        onChange: function(selectedDates, dateStr, instance) {
            if (dateStr !== "") {
                closeIconDate.style.display = "block";
            } else {
                closeIconDate.style.display = "none";
            }
            let selectedDate = selectedDates[0];
            $('#starting_from').prop('value', undefined);
            $(".select-date > p").text(undefined);
            if (selectedDate) {
              $("#starting_from").prop('value', momentify(selectedDate).format('YYYY-MM-DD'))
              $(".select-date > p").text(momentify(selectedDate).format('ddd, DD MMM YYYY'));
            }
        },
    });

    function showCalendarFromToday(instance) {
      const startingFrom = window.startingFrom
        || ($('#datepicker-picker').val() && formatDateISO($('#datepicker-picker').val()))
        || undefined;
      if (startingFrom && isMobileScreen) {
        const diffMonths = Math.round(momentify(startingFrom).diff(new Date(), 'months', true));
        if (diffMonths > 0 && diffMonths < 2) {
          instance.changeMonth(-1);
        } else {
          for (let i = 0; i < diffMonths; i++) {
            instance.changeMonth(-1);
          }
        }
      }
    }

    window.addEventListener('pageshow', () => {
      showCalendarFromToday(calendar);
    })


    if(isAdMobileDate) {
        var parentAllMonthsDivRental = document.querySelector('.carsub_datepicker .flatpickr-innerContainer .flatpickr-rContainer');
        if (parentAllMonthsDivRental) {
          if ($('#starting_from').val().length) {
            let todayIsDisplayed = false;
            while (!todayIsDisplayed) {
              $('.flatpickr-prev-month').click();

              if ($('span.flatpickr-day.today').length) {
                todayIsDisplayed = true;
              }
            }
          }

          var newDivAllMonthsRental = parentAllMonthsDivRental.appendChild(document.createElement('div'));
          newDivAllMonthsRental.className = 'all-months-name';

          for (let i = 1; i <= 20; i++) {
              var newDivSelectRental = newDivAllMonthsRental.appendChild(document.createElement('div'));
              newDivSelectRental.className = 'month-name-' + i + ' months-load-more';

              const secondMonthContainerRental = document.querySelector('.carsub_datepicker .flatpickr-months div:nth-child(' + (i + 1) + ')');
              const destinationContainerRental = newDivSelectRental;

              while (secondMonthContainerRental.firstChild) {
                  destinationContainerRental.appendChild(secondMonthContainerRental.firstChild);
              }
          }
        }


        var parentDivbutton = document.querySelector('.carsub_datepicker .flatpickr-innerContainer .flatpickr-rContainer');
        if (parentDivbutton) {
            var loadMoreButtonContainer = parentDivbutton.appendChild(document.createElement('div'));
            loadMoreButtonContainer.className = 'dates_load';

            var loadMoreButton = loadMoreButtonContainer.appendChild(document.createElement('button'));
            loadMoreButton.textContent = window.i18next.t('first_page.subscription.load_more_dates');
            loadMoreButton.id = 'load_dates_mobile';

            loadMoreButton.addEventListener('click', function() {
              //
            });
        }

        function collideWithMonthDays(monthName, dayContainer) {
          const rect1 = monthName.getBoundingClientRect();

          let height = 0;
          Array.from(dayContainer.children).forEach(el => {
            const rect2 = el.getBoundingClientRect();
            const horizontalTouch = rect1.right >= rect2.left && rect1.left <= rect2.right;
            const verticalTouch = rect1.bottom >= rect2.top && rect1.top <= rect2.bottom;

            if(horizontalTouch && verticalTouch) {
              height = rect2.height;
            }
          });

          return { height };
        }

        function updateMonthVisibility() {
            $('.carsub_datepicker .dayContainer').slice(visibleMonthsRental).css('display', 'none'); // Hide all months initially
            $('.carsub_datepicker .all-months-name .months-load-more').css('display', 'none'); // Hide all "load more" buttons initially

            $('.carsub_datepicker .dayContainer').slice(0, visibleMonthsRental).css('display', 'grid'); // Show the initially visible months
            $('.carsub_datepicker .all-months-name .months-load-more:nth-child(-n+' + visibleMonthsRental + ')').css('display', 'block'); // Show the corresponding "load more" buttons
        }

        var visibleMonthsRental = 4;
        $('.carsub_datepicker #load_dates_mobile').on('click', function () {
            $('.carsub_datepicker .dayContainer').slice(visibleMonthsRental, visibleMonthsRental + 4).css('display', 'grid');
            $('.carsub_datepicker .all-months-name .months-load-more:nth-child(-n+' + (visibleMonthsRental + 4) + ')').css('display', 'block');

            updateMonthNameStyle()

            visibleMonthsRental += 4;
            if (visibleMonthsRental >= $('.carsub_datepicker .dayContainer').length) {
                $('.carsub_datepicker #load_dates_mobile').css('display', 'none');
            }
        });

        function updateMonthNameStyle() {
          $('.months-load-more[style="display: block;"]').each(function (index) {
            const dayContainer = $('.dayContainer[style="display: grid;"]').eq(index)[0];

            const {height} = collideWithMonthDays(dayContainer, $(this).find('.flatpickr-current-month')[0])
            if (height) {
              $(this).find('.flatpickr-current-month').css('margin-top', '-' + (height + 2) + 'px');

              while(true) {
                const {height} = collideWithMonthDays(dayContainer, $(this).find('.flatpickr-current-month')[0]);
                if (height) {
                  const currentMargin = parseInt($(this).find('.flatpickr-current-month').css('margin-top'));
                  $(this).find('.flatpickr-current-month').css('margin-top', (currentMargin + (height * -1)) + 'px');
                }

                if (!height) {
                  break;
                }
              }
            }

            const previousDayContainer = $('.dayContainer[style="display: grid;"]').eq(index - 1)[0];
            while (true) {
              const {height} = collideWithMonthDays(previousDayContainer, $(this).find('.flatpickr-current-month')[0]);
              if (height) {
                const currentMargin = parseInt($(this).find('.flatpickr-current-month').css('margin-top'));
                $(this).find('.flatpickr-current-month').css('margin-top', (currentMargin + height) + 'px');
              }

              if (!height) {
                break;
              }
            }
          });
          $('.month-name-1 .flatpickr-current-month').css('margin-top', '0px');

          $('.flatpickr-current-month input').attr('readonly', 'readonly');
        }

        homepagecarsubDate._flatpickr.config.onOpen.push(updateMonthVisibility);
        homepagecarsubDate._flatpickr.config.onOpen.push(updateMonthNameStyle);

        var carsubDatepickerEndDiv = document.querySelector('.carsub_datepicker');
        // Code block for creating elements in carsub_datepicker
        var newDiv = document.createElement('div');
        newDiv.classList.add('flatpickr-header');
        var newPTag = document.createElement('p');
        newPTag.textContent = window.i18next.t('first_page.subscription.select_date');
        newDiv.appendChild(newPTag);

        var closeButton = document.createElement('button');
        closeButton.classList.add('flatpickr-close');
        var closeIcon = document.createElement('i');
        closeIcon.classList.add('fa-solid', 'fa-xmark');
        closeButton.appendChild(closeIcon);
        newDiv.appendChild(closeButton);

        carsubDatepickerEndDiv.appendChild(newDiv);

        var parentDiv = document.createElement('div');
        parentDiv.className = 'flatpickr-content';
        carsubDatepickerEndDiv.appendChild(parentDiv);

        var newDivStarting = document.createElement('div');
        newDivStarting.className = 'starting-date';
        carsubDatepickerEndDiv.appendChild(newDivStarting);

        var headingStarting = document.createElement('h3');
        headingStarting.textContent = window.i18next.t('first_page.subscription.starting_when');
        newDivStarting.appendChild(headingStarting);

        var newDivSelect = document.createElement('div');
        newDivSelect.className = 'select-date';
        carsubDatepickerEndDiv.appendChild(newDivSelect);

        var paragraphSelects = document.createElement('p');
        paragraphSelects.textContent = window.i18next.t('first_page.subscription.select_date');
        newDivSelect.appendChild(paragraphSelects);

        var parentDivs = document.createElement('div');
        parentDivs.className = 'flatpickr-footer';
        carsubDatepickerEndDiv.appendChild(parentDivs);

        var linkElements = document.createElement('a');
        linkElements.href = 'javascript:void(0);';
        linkElements.textContent = window.i18next.t('first_page.subscription.back');
        linkElements.className = 'flatpickr-close';
        parentDivs.appendChild(linkElements);

        var buttonElements = document.createElement('button');
        var iconElements = document.createElement('i');
        iconElements.className = 'fas fa-search';
        buttonElements.appendChild(iconElements);
        var buttonText = document.createElement('p');
        buttonText.className = 'inline-block';
        buttonText.textContent = window.i18next.t('first_page.subscription.search');
        buttonElements.appendChild(buttonText)
        buttonElements.className = 'button-orange';
        parentDivs.appendChild(buttonElements);
    }
});
// document.addEventListener("DOMContentLoaded", function() {
//     var carSubscriptionRadio = document.getElementById('carSubscriptionHome');
//     var rentalDatepickerStart = document.querySelector(".rental_datepicker_start");
//     var rentalDatepickerEnd = document.querySelector(".rental_datepicker_end");
//     var CarRentalhomeRadio = document.getElementById('CarRentalhome');
//
//     CarRentalhomeRadio.addEventListener("change", function() {
//         if (this.checked) {
//             rentalDatepickerStart.style.display = "";
//             rentalDatepickerEnd.style.display = "";
//             rentalDatepickerStart.classList.remove("open");
//             rentalDatepickerEnd.classList.remove("open");
//         } else {
//             rentalDatepickerStart.style.display = ""; // Reset to default display
//             rentalDatepickerEnd.style.display = ""; // Reset to default display
//         }
//     });
//
//     carSubscriptionRadio.addEventListener("change", function() {
//         if (this.checked) {
//             rentalDatepickerStart.style.display = "none";
//             rentalDatepickerEnd.style.display = "none";
//             rentalDatepickerStart.classList.remove("open");
//             rentalDatepickerEnd.classList.remove("open");
//         } else {
//             rentalDatepickerStart.style.display = ""; // Reset to default display
//             rentalDatepickerEnd.style.display = ""; // Reset to default display
//         }
//     });
//
// });
